import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_TICKETS_LIST = gql`
query getTicketsList ($search: String, $limit: Int, $offset: Int, $issue: String, $sortField: String, $sortOrder: Int){
    getTicketsList(search: $search, limit: $limit, offset: $offset, issue: $issue, sortField: $sortField, sortOrder: $sortOrder) {
      isAuth
      total
      tickets {
        _id
        createdAt
        description {
          en
          es
          ca
          pt
        }
        updatedAt
        postUri
        # Resolved through the events join, not stored on the ticket: postUri
        # above has never been persisted by postAddTicket.
        eventSlugName
        postSlugNames
        price
        tags
        sellers {
          sellerSlugName
          sellerName
          priority
          active
          sellerTicketUrl
        }
        show
        showFee
        ticketName
        currency
        status 
        ticketReadableName {
          en
          es
          ca
          pt
        }
        subtitle {
          en
          es
          ca
          pt
        }
        ticketSlugName
        date
        venueSlugName
      }
    }
  }
`;

const getTicketsList = async (search = '', { limit, offset, issue, sortField, sortOrder } = {}) => {
  try {
    const result = await client
      .query({
        query: GET_TICKETS_LIST,
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
        variables: { search, limit, offset, issue, sortField, sortOrder },
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getTicketsList: ticketsListData },
    } = result;

    if (ticketsListData) {
      return ticketsListData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getTicketsList = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getTicketsList Error: ${error}`);
    return null;
  }
};

export default getTicketsList;
